import { graphql } from 'react-relay';
export const GetPersonalSpaceKeyQuery = graphql`
	query GetPersonalSpaceKeyQuery {
		user: confluence_atlassianUser(current: true) {
			id
			confluence {
				hasPersonalSpace
				space {
					id
					key
				}
			}
		}
	}
`;
